// extracted by mini-css-extract-plugin
export default {"frequencyContainer":"DonationInterval_frequencyContainer__Dppj1","frequencyTitle":"DonationInterval_frequencyTitle__7LVTL","frequencies":"DonationInterval_frequencies__e1Py0"};